// extracted by mini-css-extract-plugin
export default {"wrapper":"yqWIyBZh82xj47vuUnwv","teamCard":"UuV13JJgIlX0qRZTGDBT"};